<template>
  <!-- <div class="topo w-100 ui-image--cover" :style="'background-image: url('+require('../assets/img/topo_blog.jpg')+')'"> -->
  <div class="topo w-100 ui-image--cover" :style="'background-image: url('+ banner +')'">
    <div class="container h-100">
      <div class="row h-100 justify-content-between align-items-center">
        <div class="col-md-6 col-12">
          <h1 class="ui-title ui-title--intern ui-title--white ui-title--uppercase">
            <b>{{titulo}}</b>
          </h1>
        </div>
        <div class="col-xl-4 col-lg-5 col-md-6 col-12">
          <div class="topo__cadastro__title">
            <h2>
              Participe para receber <br><b>prêmios exclusivos</b>
            </h2>
            <button class="ui-button ui-button--transparent-white" @click="scrollBotton()">
              Quero Participar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'banner', 'titulo'
  ],
  methods: {
    scrollBotton () {
      window.scroll({
        top: 1200,
        left: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';
.topo {
  height: 70vh;
  padding-top: 100px;
  @media (max-width: 1600px) {
    height: 60vh;
  }
  @media (max-width: 1400px) {
    height: 65vh;
  }
  @media (max-width: 500px){
    height: 60vh;
    .ui-title--intern {
      text-align: center!important;
    }
  }
  &__cadastro__title {
    h2 {
      color: white;
      font-size: 24px;
      line-height: 24px;
      margin-bottom: 40px;
      b {
        font-weight: 900;
      }
    }
    button {
      min-width: inherit;
      width: 100%;
    }
  }
  .modal-header {
    h5 {
      font-size: 24px;
    }
  }
  @media (max-width: 991px){
  }
  @media (max-width: 767px){
    &__cadastro__title {
      h2 {
        font-size: 22px;
        margin-bottom: 30px;
        text-align: center
      }
    }
    .modal-header {
      h5 {
        font-size: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BannerCampaig.vue